import shuffle from 'lodash/shuffle';
import { Training } from '@/interfaces/class/training';

export default (el: Training) => {
  const { enSlices, enSlicesWrong } = el;

  const enFillersCorrect = enSlices.split('\n');
  const enFillersShuffled = enSlicesWrong.split('\n').map((slice: string, i: number) => shuffle(shuffle(slice.split('/')).splice(0, 2).concat([enFillersCorrect[i]])));

  return {
    ...el,
    allAllowedTrainingTypes: ['TranslatePhrase'],
    allowedTrainingTypes: ['TranslatePhrase'],
    enFillersCorrect,
    enFillersShuffled,
    partResults: {},
  };
};
